import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 1,
  name: '暮れの酉',
  kana: 'くれのとり',
  roman: 'Kurenotori',
  mainMethod: '鳳凰数術',
  mainMethodKana: 'ほうおうすうじゅつ',
}

const additionalInfo = {
  description: `大阪ミナミの老舗占い館で18年間No.1の座に君臨。朝からできる長蛇の列で彼の出演日がわかるという。人気の秘訣はとにかく当たると評判の鑑定技術と柔和な鑑定スタイル。鍛え上げられた占術と包み込むような会話術は訪れるすべての人に心を開かせ、寄り添いながらカタルシスへと導く。`,
  methods: '鳳凰数術、タロット',
  yearsOfAppraisal: `${diffFromBase + 19}年`,
  appraisalNum: '８万人以上',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/kurenotori/profileImage1.png',
  directAppraisal: {
    message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  salonTypeCommunity: {
    name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
    url: '',
  }
}

const tellerList = {
  description: '古今東西の占術を極め、19年間行列を絶やさなかった伝説の占い師',
  thumbnail: '/static/img/recommend/lp/kurenotori/counselor_160x160.jpg',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/info/profile.js